import React, { useEffect } from 'react'; // Added useEffect
import { useLocation } from 'react-router-dom'; // Added useLocation
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import { Mail, GraduationCap, Award, Video, Globe, CheckCircle2 } from 'lucide-react';
import './HomePage.css'; // Importing a clean companion style file for layout
import './Waves.css';

import { Baby, HeartPulse, Activity } from 'lucide-react'; // Add these to your lucide imports

import alisa_zuka from 'assets/alisa_zuka.jpg'




































function Homepage() {




    const location = useLocation();

    useEffect(() => {
        // Check if navigation passed an anchor ID state
        if (location.state && location.state.scrollToId) {
            const targetId = location.state.scrollToId;

            // Give the DOM a tiny fraction of a second to render fully before moving
            const timer = setTimeout(() => {
                const element = document.getElementById(targetId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }

                // Clear the state history so refreshing the page doesn't trigger auto-scrolling
                window.history.replaceState({}, document.title);
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [location]);





    return (
        <div className="homepage-wrapper">
            <Navbar />

            {/* 1. HOME / ABOUT SECTION */}
            <section id="about" className="section-hero"
                style={{
                    // background: '#ebdcfa'
                    background: '#dbf0ff'
                }}>





                {/* Background SVGs */}
                <div className="svg-bg-wrapper">
                    {/* Top Right Smooth Organic Curve */}
                    <svg className="abstract-shape shape-top-right" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0,0 C150,50 350,200 400,400 L400,0 Z" fill="#dfc6f7" opacity="0.6" />
                    </svg>

                    {/* Bottom Left Floating Soft Circle */}
                    <svg className="abstract-shape shape-bottom-left" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="100" r="100" fill="#d1b3f2" opacity="0.4" />
                    </svg>
                </div>



                <div className="hero-content">
                    {/* <p className="subtitle_v2">Welcome to <wbr /> Confident Expression LLC</p> */}

                    <p className="subtitle_v2">Welcome to <wbr />  <span style={{ whiteSpace: 'nowrap' }}>Confident Expression LLC</span></p>

                    <h1>{`Alisa Zuka`}</h1>
                    <img src={alisa_zuka}
                        style={{
                            height: '40vh',
                            borderRadius: '1rem',
                            boxShadow: '7px 5px 5px rgba(185, 155, 250, 0.8)',
                            border: '2px solid #e1bef5'
                        }} />


                    {/* <h2>{`M.A., M.S., CCC-SLP, CSLD-I`}</h2> */}
                    <p className="bio-title">Board Certified Speech-Language Pathologist</p>


                    <div className="bio-text">




                        <p className="closing-callout"
                            style={{
                                fontStyle: 'italic',
                                borderLeft: '3px solid #6366f1',
                                paddingLeft: '1rem',
                                marginTop: '2rem',
                                color: '#6366f1',
                                fontWeight: 'bold',
                            }}>
                            Thank you for visiting my page, I hope to connect with you soon and become a part of your journey toward confident expression!
                        </p>





                        <p style={{ fontSize: '1.15rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                            <strong>Welcome!</strong> I'm Alisa, owner of Confident Expression LLC. I am a licensed speech and language pathologist (SLP) and Certified Structured Literacy/Dyslexia Interventionist (through the Center for Effective Reading Instruction).
                            <br></br>
                            <br></br>
                            I am licensed through the state of Massachusetts and hold a Certificate of Clinical Competence through the American Speech and Hearing Association (ASHA).
                        </p>

                        <p style={{ marginBottom: '0.5rem' }}>After working across a variety of settings, including private practices and schools, I founded this practice to bring specialized, targeted expertise directly to my community.</p>



















                        {/* <div className="bio-experience" style={{ marginTop: '4rem', marginBottom: '1.5rem' }}>
                            <h3 style={{ marginBottom: '0.5rem', textAlign: 'left' }}>My clinical expertise includes:</h3>

                            <ul style={{
                                // marginLeft: '1.25rem', 
                                lineHeight: '1.5', marginBottom: '1rem', listStyleType: 'disc', textAlign: 'left'
                            }}>
                                <li style={{ marginBottom: '0.25rem' }}><strong>Pediatric Care:</strong> Tailored speech and language intervention for children.</li>
                                <li style={{ marginBottom: '0.25rem' }}><strong>Adult Rehabilitation:</strong> Comprehensive therapy for aphasia, motor speech disorders, and cognitive changes stemming from strokes or brain injuries.</li>
                                <li style={{ marginBottom: '0.25rem' }}><strong>Accent Modification:</strong> Specialized coaching for adults looking to increase their clarity, intelligibility, and public speaking confidence.</li>
                            </ul>
                        </div> */}







                        {/* <div className="content-card">
                        <div className="card-header">
                            <GraduationCap className="section-icon" />
                            <h2>Pediatric Care:</h2>
                        </div>
                        <p>Tailored speech and language intervention for children.</p>
                    </div>


                    <div className="content-card">
                        <div className="card-header">
                            <GraduationCap className="section-icon" />
                            <h2>Adult Rehabilitation</h2>
                        </div>
                        <p>Comprehensive therapy for aphasia, motor speech disorders, and cognitive changes stemming from strokes or brain injuries.</p>
                    </div>


                    <div className="content-card">
                        <div className="card-header">
                            <GraduationCap className="section-icon" />
                            <h2>Accent Modification:</h2>
                        </div>
                        <p>Specialized coaching for adults looking to increase their clarity, intelligibility, and public speaking confidence.</p>
                    </div> */}







                        <p className="closing-callout"
                            style={{
                                fontStyle: 'italic',
                                borderLeft: '3px solid #6366f1',
                                paddingLeft: '1rem',
                                marginTop: '2rem',

                                color: '#6366f1',
                                fontWeight: 'bold',
                            }}>
                            My passion is to increase confidence in how my clients express themselves.
                        </p>









                        {/* --- CLINICAL EXPERTISE TRACK --- */}
                        <div className="bio-experience-container">
                            <h3 className="expertise-main-title">My clinical expertise includes:</h3>

                            <div className="expertise-cards-grid">

                                {/* Item 1: Pediatrics */}
                                <div className="expertise-card">
                                    <div className="expertise-card-header">
                                        <div className="expertise-icon-wrapper">
                                            <Baby size={20} />
                                        </div>
                                        <h2>Pediatric Care</h2>
                                    </div>
                                    <p>Tailored speech and language intervention for children.</p>
                                </div>

                                {/* Item 2: Adults */}
                                <div className="expertise-card">
                                    <div className="expertise-card-header">
                                        <div className="expertise-icon-wrapper">
                                            <HeartPulse size={20} />
                                        </div>
                                        <h2>Adult Rehabilitation</h2>
                                    </div>
                                    <p>Comprehensive therapy for aphasia, motor speech disorders, and cognitive changes stemming from strokes or brain injuries.</p>
                                </div>

                                {/* Item 3: Accents */}
                                <div className="expertise-card">
                                    <div className="expertise-card-header">
                                        <div className="expertise-icon-wrapper">
                                            <Activity size={20} />
                                        </div>
                                        <h2>Accent Modification</h2>
                                    </div>
                                    <p>Specialized coaching for adults looking to increase their clarity, intelligibility, and public speaking confidence.</p>
                                </div>

                            </div>
                        </div>















                        <p className="closing-callout"
                            style={{
                                fontStyle: 'italic',
                                borderLeft: '3px solid #6366f1',
                                paddingLeft: '1rem',
                                marginTop: '2rem',

                                color: '#6366f1',
                                fontWeight: 'bold',
                            }}>
                            I aim to create a productive and engaging environment that helps my clients achieve their goals.
                        </p>


                        {/* <p className="closing-callout"
                            style={{
                                fontStyle: 'italic',
                                borderLeft: '3px solid #6366f1',
                                paddingLeft: '1rem',
                                marginTop: '2rem',
                            }}>
                            My passion is to increase confidence in how my clients express themselves. <br></br>
                            <br></br>
                            I aim to create a productive and engaging environment that helps my clients achieve their goals.
                            <br></br>
                            <br></br>
                            Thank you for visiting my page, I hope to connect with you soon and become a part of your journey toward confident expression!
                        </p> */}







                        <div className="bio-credentials" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
                            <h3 style={{ marginTop: '4rem', marginBottom: '0.5rem', }}>Certifications & Education</h3>
                            <ul style={{ marginLeft: '1.25rem', lineHeight: '1.5', marginBottom: '1rem', listStyleType: 'disc' }}>


                                <li style={{ marginBottom: '0.25rem' }}><strong>Certificate of Clinical Competence</strong> (American Speech-Language-Hearing Association - ASHA)</li>

                                <li style={{ marginBottom: '0.25rem' }}><strong>Licensed Speech & Language Pathologist</strong> (State of Massachusetts)</li>


                                <li style={{ marginBottom: '0.25rem' }}><strong>Certified Structured Literacy/Dyslexia Interventionist</strong> (Center for Effective Reading Instruction)</li>

                                <li style={{ marginBottom: '0.25rem' }}><strong>M.A. in Applied Developmental Psychology</strong> – University of Maryland Baltimore County</li>


                                <li style={{ marginBottom: '0.25rem' }}><strong>M.S. in Communication Sciences and Disorders</strong> – MGH Institute of Health Professions</li>

                            </ul>
                        </div>




































                    </div>
                </div>

                <div className="wave-container">
                    <svg viewBox="0 0 1200 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C26.9,3,57.05,11.58,87.6,18.57,152,33.22,217.15,64.29,321.39,56.44Z"
                            fill="#e1bef5" /* Matches the Services background color exactly */
                        />
                    </svg>
                </div>


            </section>

            {/* 2. SERVICES & CERTIFICATIONS (Replacing Placeholder Testimonials) */}
            <section id="services" className="section-details" style={{ background: '#e1bef5' }}>
                <div className="grid-container">

                    {/* Column A: Services */}
                    <div className="content-card">
                        <div className="card-header">
                            <Award className="section-icon" />
                            <h2>Services</h2>
                        </div>
                        <ul className="services-list">
                            <li>Accent Modification</li>
                            <li>Disorders of Written Language (e.g., Dyslexia)</li>
                            <li>Expressive and Receptive Language Disorders</li>
                            <li>Articulation/Phonological Disorders</li>
                            <li>Aphasia</li>
                            <li>Fluency Disorders</li>
                            <li>Consultative Services for Speech and Language</li>
                        </ul>

                        <div className="delivery-box">
                            <h3><Video size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} /> Service Delivery</h3>
                            <p style={{fontSize:'1rem',fontWeight:'bold',lineHeight:'1.5rem'}}>Services are currently provided virtually over Zoom (some exceptions apply).</p>
                            <p className="payment-tag" style={{fontSize:'1.2rem', textAlign:'center', margin:'1rem'}}>Private Pay Only</p>
                        </div>
                    </div>

                    {/* Column B: Training & Certifications */}
                    <div className="content-card">
                        <div className="card-header">
                            <GraduationCap className="section-icon" />
                            <h2>Training &amp; Certifications</h2>
                        </div>
                        <ul className="cert-list">
                            <li>
                                <CheckCircle2 size={16} className="bullet-icon" />
                                Certified by the American Speech-Hearing Association (ASHA)
                            </li>
                            <li>
                                <CheckCircle2 size={16} className="bullet-icon" />
                                Licensed within Massachusetts
                            </li>
                            <li>
                                <CheckCircle2 size={16} className="bullet-icon" />
                                Certified Structured Literacy Dyslexia Interventionist (CSLD-I)
                            </li>
                            <li>
                                <CheckCircle2 size={16} className="bullet-icon" />
                                Trained in Orton-Gillingham (OG)
                            </li>
                            <li>
                                <CheckCircle2 size={16} className="bullet-icon" />
                                Certified in the Rupp Method for Accent Modification
                            </li>

                        </ul>
                    </div>

                </div>


                {/* WAVY BRIDGE TO CONTACT */}
                <div className="wave-container">
                    <svg viewBox="0 0 1200 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C26.9,3,57.05,11.58,87.6,18.57,152,33.22,217.15,64.29,321.39,56.44Z"
                            fill="#b99bfa" /* Matches the Contact background color exactly */
                        />
                    </svg>
                </div>


            </section>


















            {/* 3. CONTACT SECTION */}
            {/* <section id="contact" className="section-contact" style={{ background: '#b99bfa' }}>



                <div className="svg-bg-wrapper">
                   
                    <svg className="abstract-shape contact-arc" viewBox="0 0 1440 400" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0,200 Q360,400 720,200 T1440,200 L1440,400 L0,400 Z" fill="#ab87f5" opacity="0.5" />
                    </svg>
                </div>



                <div className="contact-card-lone">
                    <h2>Get In Touch</h2>
                    <p>Have questions or ready to schedule a virtual intake session? Send a message below or email directly at <strong>confidentexpressionllc@gmail.com</strong></p>

                    <form
                        className="contact-form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            // Handle form submission logic here (e.g., Formspree, Netlify Forms, or Web3Forms)
                            alert('Thank you! Your message has been sent.');
                        }}
                    >
                        <div className="form-group">
                            <label htmlFor="name">Full Name</label>
                            <input
                                type="text"
                                id="name"
                                required
                            // placeholder="Jane Doe"
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    required
                                // placeholder="jane.doe@example.com"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    type="tel"
                                    id="phone"
                                // placeholder="(555) 000-0000"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">How can Alisa help you?</label>
                            <textarea
                                id="message"
                                rows="4"
                                required
                                placeholder=''
                            // placeholder="Please let us know if you are inquiring about services for an adult or child, and any specific communication goals..."
                            ></textarea>
                        </div>

                        <button type="submit" className="submit-btn">
                            Send Message
                        </button>
                    </form>
                </div>
            </section> */}




















            {/* 3. CONTACT SECTION */}
            <section id="contact" className="section-contact" style={{ background: '#b99bfa' }}>

                <div className="svg-bg-wrapper">
                    {/* Giant Swooping Arc Backdrop */}
                    <svg className="abstract-shape contact-arc" viewBox="0 0 1440 400" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0,200 Q360,400 720,200 T1440,200 L1440,400 L0,400 Z" fill="#ab87f5" opacity="0.5" />
                    </svg>
                </div>

                {/* Brand new card class to separate layout rules from your old form card */}
                <div className="direct-contact-card">
                    <h2>Get In Touch</h2>
                    <p className="contact-lead-text">
                        Have questions or ready to schedule a virtual intake session?
                        Alisa is currently accepting new clients. Please reach out directly via email to coordinate details.
                    </p>

                    {/* Interactive Email Anchor Box */}
                    <a
                        href="mailto:confidentexpressionllc@gmail.com"
                        className="email-action-box"
                        title="Open default email application"
                    >
                        <div className="email-icon-badge">
                            <Mail size={24} />
                        </div>
                        <div className="email-details">
                            <span className="email-label">Direct Email Address</span>
                            <span className="email-address">confidentexpressionllc@gmail.com</span>
                        </div>
                    </a>

                    <p className="contact-footer-note">
                        Clicking the box above will automatically open your preferred email client.
                    </p>
                </div>
            </section>



















            <Footer></Footer>
        </div>
    );
}

export default Homepage;